module.exports = __webpack_public_path__ + "img/inside_bouloire.33e68d40.jpg";